/**
 * Recently Viewed Tracker WebComponent
 * Tracks product views and stores them in localStorage
 */
class RecentlyViewedTracker extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'recently_viewed_products';
    this.maxProducts = 8; // Store max 8, display max 4
  }

  connectedCallback() {
    this.trackProduct();
  }

  trackProduct() {
    const productData = {
      id: this.dataset.productId,
      handle: this.dataset.productHandle,
      title: this.dataset.productTitle,
      url: this.dataset.productUrl,
      image: this.dataset.productImage,
      price: this.dataset.productPrice,
      viewedAt: Date.now()
    };

    // Store product-specific data only (not theme-wide settings)
    // Theme settings should be fetched from current settings, not cached
    if (this.dataset.tickBoxes) {
      try {
        productData.tickBoxes = JSON.parse(this.dataset.tickBoxes);
      } catch (e) {
        // Silent fail for tick boxes
      }
    }

    if (this.dataset.looxNumReviews) {
      productData.looxNumReviews = this.dataset.looxNumReviews;
    }
    if (this.dataset.looxAvgRating) {
      productData.looxAvgRating = this.dataset.looxAvgRating;
    }

    if (this.dataset.productLabel) {
      productData.productLabel = this.dataset.productLabel;
    }
    
    if (this.dataset.badgeBackgroundColor) {
      productData.badgeBackgroundColor = this.dataset.badgeBackgroundColor;
    }
    
    if (this.dataset.badgeTextColor) {
      productData.badgeTextColor = this.dataset.badgeTextColor;
    }

    if (this.dataset.preOrderMessage) {
      productData.preOrderMessage = this.dataset.preOrderMessage;
    }

    if (!productData.id || !productData.handle) return;

    try {
      const products = this.getRecentlyViewed();
      const filtered = products.filter(p => p.id !== productData.id);
      filtered.unshift(productData);

      const updated = filtered.slice(0, this.maxProducts);
      localStorage.setItem(this.storageKey, JSON.stringify(updated));

      this.dispatchEvent(new CustomEvent('recently-viewed-updated', {
        detail: { products: updated },
        bubbles: true
      }));
    } catch (error) {
      // Silent fail
    }
  }

  getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      return [];
    }
  }
  static clearRecentlyViewed() {
    try {
      localStorage.removeItem('recently_viewed_products');
    } catch (error) {
      // Silent fail
    }
  }
}

customElements.define('recently-viewed-tracker', RecentlyViewedTracker);
